export default __webpack_public_path__ + "static/lady-typing-6da2e8d1337cf62c80ffea06d93633c6.png";